import type { NotificationsPanelProps } from '../../types';
import NotificationPanelBody from './NotificationPanelBody';
import NotificationPanelFooter from './NotificationPanelFooter';
import NotificationPanelHeader from './NotificationPanelHeader';
import NotificationPanelTabs from './NotificationPanelTabs';

const NotificationsPanel = ({
  notifications,
  activeTab,
  onTabChange,
  onClose,
  onMarkAllAsRead,
  onDismissAll,
  onDismiss,
  onMarkReadStatus,
  onLoadMore,
  hasMore,
  isLoading,
  totalCount = 0,
  unreadCount = 0
}: NotificationsPanelProps) => (
  <div className="tw:flex tw:w-max tw:min-w-115.75 tw:max-w-lg tw:h-160 tw:flex-col">
    <NotificationPanelHeader onClose={onClose} />
    <NotificationPanelTabs
      activeTab={activeTab}
      onTabChange={onTabChange}
      totalCount={totalCount}
      unreadCount={unreadCount}
      onDismissAll={onDismissAll}
      onMarkAllAsRead={onMarkAllAsRead}
    />
    <NotificationPanelBody
      notifications={notifications}
      isLoading={isLoading}
      hasMore={hasMore}
      onLoadMore={onLoadMore}
      onDismiss={onDismiss}
      onMarkReadStatus={onMarkReadStatus}
    />
    <NotificationPanelFooter onClose={onClose} />
  </div>
);

export default NotificationsPanel;
